// apps/web/src/shared/utils/iban.ts

export function normalizeIban(input: string): string {
  return (input ?? "").replace(/\s+/g, "").toUpperCase();
}

export function isValidIban(input: string): boolean {
  const iban = normalizeIban(input);

  if (iban.length < 15 || iban.length > 34) return false;
  if (!/^[A-Z0-9]+$/.test(iban)) return false;

  const rearranged = iban.slice(4) + iban.slice(0, 4);

  let remainder = 0;

  for (let i = 0; i < rearranged.length; i++) {
    const ch = rearranged[i];

    if (ch >= "0" && ch <= "9") {
      remainder = (remainder * 10 + (ch.charCodeAt(0) - 48)) % 97;
    } else {
      const value = ch.charCodeAt(0) - 55; 
      remainder = (remainder * 10 + Math.floor(value / 10)) % 97;
      remainder = (remainder * 10 + (value % 10)) % 97;
    }
  }

  return remainder === 1;
}
